import { apiUrl } from "../enviroments/enviroments.dev";
import { Api } from "./Api";

const target = "/transactions";

export class TransactionService {
    public static getLatestTransactions (pagina:number) {
        return Api.get(apiUrl(target+"/latest?pagina="+pagina));
    }

    public static getAmountByDates(sd:string,ed:string,status:string) {
        return Api.get(apiUrl(target+"/getByDate?startDate="+sd+"&endDate="+ed+"&status="+status))
    }

    public static getHistopryByWallet(walletId:number) {
        return Api.get(apiUrl(target+"/"+walletId))
    }

    // POST /transactions/search filtrando por tipo de operacao da org
    // (ex.: "ProfitWithdraw", "ProfitTransfer").
    // range: ?date_start=YYYY-MM-DD&date_end=YYYY-MM-DD (ambos opcionais),
    // aplicado sobre createdAt no backend.
    public static searchByOperationType(
        organizationId: number,
        operationType: string,
        range?: { date_start?: string; date_end?: string },
    ) {
        const qs = new URLSearchParams();
        if (range?.date_start) qs.set("date_start", range.date_start);
        if (range?.date_end)   qs.set("date_end", range.date_end);
        const query = qs.toString();
        return Api.post(apiUrl(target + "/search" + (query ? "?" + query : "")), {
            filters:  { organization_id: organizationId, operation_type: operationType },
            pageSize: 200,
        });
    }
}
